// ##### Komarov 2025-07-18
import React from 'react';
import { Media } from '../../../../helpers/MediaConfig.js';
// ##### Komarov 2025-07-18
import { useDispatch, useSelector } from 'react-redux';
// ##### Komarov 2025-07-19
import { getPax, setPaxListOpen } from '../../../../Redux/actions/paxchoice.js';
import HotelsPaxChoiceGridPageDevices from './HotelsPaxChoiceGridPageDevices.jsx';
import HotelsPaxChoicePopUpButtonPageDevices from './HotelsPaxChoicePopUpButtonPageDevices.jsx';

// ##### Komarov 2025-07-14
const HotelsPaxChoicePopUpPageDevices = ({
  width,
  // ##### 23-11-15 Komarov
  screenIsSmall = false,
  isSecondSearch = false,
  // screenWidthClassName = ''
}) => {
  // ##### Komarov 2025-07-18
  const dispatch = useDispatch();

  const { adults: counterAdults, children: counterChild, rooms: counterRooms } = useSelector(state => state.paxchoice.pax);
  const { paxListOpen } = useSelector(state => state.paxchoice);

  const TotalPax = () => {
    dispatch(getPax(counterAdults, counterChild, counterRooms));
  };

  // ##### 23-11-08 Komarov
  return (
    <div
      // className={screenWidthClassName + " " + (paxListOpen === false ? 'PopUpNotActive' : 'PopUpActive')}
      // ##### 23-11-14 Komarov
      // className={paxListOpen === false ? 'PopUpNotActive' : 'PopUpActive'}
      // ##### 24-01-30 Komarov
      data-component="HotelsPaxChoicePopUpPageDevices"
      className={
        ((!screenIsSmall || isSecondSearch) &&
          (paxListOpen === false
            ? 'PopUpNotActive'
            : 'PopUpActive-PageDevices')) ||
        'PopUpActive-PageDevices'
      }
      // ##### 23-04-28 Komarov
      style={{ width }}
      onClick={e => {
        // ##### 23-12-27 Komarov
        dispatch(setPaxListOpen(true));
        e.stopPropagation();
      }}
      // ##### 24-03-21 Komarov
      onKeyDown={e => {
        if (e.key === 'Enter') {
          dispatch(setPaxListOpen(true));
          e.stopPropagation();
        }
      }}
      id={
        process.env.NODE_ENV === 'development' &&
        'src/Components/Library/PageDevices/HotelsPaxChoicePopUpPageDevices.jsx:PopUpDivTag'
      }
    >
      {/* ##### 23-11-08 Komarov */}
      <Media greaterThanOrEqual="Laptop-1024-1440">
        <HotelsPaxChoiceGridPageDevices rowGap="10px" />
      </Media>
      <Media lessThan="Laptop-1024-1440">
        <HotelsPaxChoiceGridPageDevices rowGap="16px" />
      </Media>

      {/* ##### 24-03-21 Komarov */}
      <div
        onClick={TotalPax}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            TotalPax();
          }
        }}
        style={{ textAlign: 'center', position: 'relative', zIndex: '3000' }}
      >
        {/* ##### 23-11-08 Komarov */}
        <Media lessThan="Laptop-1024-1440">
          <HotelsPaxChoicePopUpButtonPageDevices marginTop="3vw" />
        </Media>
        <Media greaterThanOrEqual="Laptop-1024-1440">
          <HotelsPaxChoicePopUpButtonPageDevices />
        </Media>
      </div>
    </div>
  );
};

// ##### 25-05-21 Komarov
export default HotelsPaxChoicePopUpPageDevices;
